import MarketplaceTravelerSummary from "./MarketplaceTravelerSummary.jsx";

export default function TripListingCard({
  trip,
  traveler,
  reputation,
  isBuyer,
  isOwner,
  onRequest,
  onDeactivate,
  onOpenReviews,
}) {
  return (
    <article className="trip-card">
      <div className="trip-card-header">
        <div className="trip-card-route-block">
          <span className="trip-card-kicker">Trip</span>
          <h3>{trip.origin}</h3>
          <p>to {trip.destination}</p>
        </div>
        <span className="pill trip-card-pill">
          {trip.remaining_slots} of {trip.slots} request slots left
        </span>
      </div>
      <p className="trip-card-date">{trip.travel_date}</p>
      {trip.description && (
        <p className="listing-description">{trip.description}</p>
      )}
      <MarketplaceTravelerSummary
        traveler={traveler}
        reputation={reputation}
        reviewLabel="View traveler reviews"
        onOpenReviews={onOpenReviews}
      >
        <div>
          {(trip.tags || []).map((tag) => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
      </MarketplaceTravelerSummary>
      <footer className="trip-card-footer">
        <b>From PHP {Number(trip.service_fee).toLocaleString()}</b>
        {isBuyer && (
          <button
            disabled={trip.remaining_slots <= 0}
            onClick={onRequest}
          >
            {trip.remaining_slots > 0 ? "Request" : "Fully booked"}
          </button>
        )}
        {isOwner && trip.active && (
          <button className="secondary" onClick={onDeactivate}>
            Deactivate trip
          </button>
        )}
      </footer>
    </article>
  );
}
